module.exports = __webpack_public_path__ + "static/media/logo.f102f5f6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/FilterBar/logo.svg
// module id = 547
// module chunks = 0